export default "__VITE_ASSET__290e253e__"